import { useRecordContext } from 'react-admin';
import DoneIcon from '@mui/icons-material/Done';

export const CustomBooleanField = ({ source, ...props }) => {
    const record = useRecordContext(props);
    const value = record[source];
  
    return value ? <DoneIcon fontSize='small'></DoneIcon> : null;
  };